import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { getEnterpriseLoginURL, getPublicLoginURL, getStoredToken, isTokenValid, isAdminUser } from '../auth/cognito';

const BG: React.CSSProperties = {
  minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center',
  background: 'linear-gradient(135deg,#0a0a1a,#0d1b3e,#050d1f)',
  fontFamily: "'Segoe UI', system-ui, sans-serif", padding: 24,
};

const CARD: React.CSSProperties = {
  background: 'rgba(255,255,255,0.06)', border: '1px solid rgba(255,255,255,0.1)',
  borderRadius: 24, padding: '48px 40px', maxWidth: 520, width: '100%',
};

const OPTION_BASE: React.CSSProperties = {
  borderRadius: 16, padding: '24px 28px', cursor: 'pointer', textDecoration: 'none',
  display: 'block', transition: 'all 0.15s', marginBottom: 12,
};

export default function Login() {
  const navigate = useNavigate();

  useEffect(() => {
    const token = getStoredToken();
    if (token && isTokenValid(token) && isAdminUser()) {
      navigate('/', { replace: true });
    }
  }, [navigate]);

  return (
    <div style={BG}>
      <div style={CARD}>
        {/* Brand */}
        <div style={{ textAlign: 'center', marginBottom: 36 }}>
          <div style={{ fontSize: 20, fontWeight: 700, color: '#fff', marginBottom: 8 }}>
            privacy<span style={{ color: '#818cf8' }}>.education</span>
          </div>
          <span style={{
            background: 'rgba(239,68,68,0.15)', border: '1px solid rgba(239,68,68,0.3)',
            color: '#fca5a5', fontSize: 10, fontWeight: 700,
            padding: '3px 12px', borderRadius: 100, letterSpacing: 2,
          }}>ADMIN PORTAL</span>
        </div>

        <h1 style={{ fontSize: 22, fontWeight: 700, color: '#fff', textAlign: 'center', margin: '0 0 8px' }}>
          Choose your platform
        </h1>
        <p style={{ fontSize: 13, color: 'rgba(255,255,255,0.4)', textAlign: 'center', lineHeight: 1.6, margin: '0 0 32px' }}>
          Sign in with the account that matches your admin role.
        </p>

        {/* Enterprise option */}
        <a
          href={getEnterpriseLoginURL()}
          style={{
            ...OPTION_BASE,
            background: 'rgba(99,102,241,0.08)',
            border: '1px solid rgba(99,102,241,0.3)',
          }}
          onMouseEnter={e => {
            (e.currentTarget as HTMLAnchorElement).style.background = 'rgba(99,102,241,0.18)';
            (e.currentTarget as HTMLAnchorElement).style.borderColor = 'rgba(99,102,241,0.6)';
          }}
          onMouseLeave={e => {
            (e.currentTarget as HTMLAnchorElement).style.background = 'rgba(99,102,241,0.08)';
            (e.currentTarget as HTMLAnchorElement).style.borderColor = 'rgba(99,102,241,0.3)';
          }}
        >
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
            <div>
              <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 6 }}>
                <div style={{ width: 32, height: 32, borderRadius: 8, background: 'rgba(99,102,241,0.25)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 16 }}>🏢</div>
                <span style={{ fontSize: 15, fontWeight: 700, color: '#a5b4fc' }}>Enterprise / Admin</span>
              </div>
              <div style={{ fontSize: 12, color: 'rgba(255,255,255,0.4)', lineHeight: 1.5 }}>
                Super Admins, Enterprise OrgAdmins
              </div>
              <div style={{ fontSize: 11, color: 'rgba(99,102,241,0.7)', marginTop: 4 }}>
                app.privacy.education · admin.privacy.education
              </div>
            </div>
            <div style={{ color: '#818cf8', fontSize: 18 }}>→</div>
          </div>
        </a>

        {/* Public option */}
        <a
          href={getPublicLoginURL()}
          style={{
            ...OPTION_BASE,
            background: 'rgba(16,185,129,0.08)',
            border: '1px solid rgba(16,185,129,0.3)',
            marginBottom: 0,
          }}
          onMouseEnter={e => {
            (e.currentTarget as HTMLAnchorElement).style.background = 'rgba(16,185,129,0.18)';
            (e.currentTarget as HTMLAnchorElement).style.borderColor = 'rgba(16,185,129,0.6)';
          }}
          onMouseLeave={e => {
            (e.currentTarget as HTMLAnchorElement).style.background = 'rgba(16,185,129,0.08)';
            (e.currentTarget as HTMLAnchorElement).style.borderColor = 'rgba(16,185,129,0.3)';
          }}
        >
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
            <div>
              <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 6 }}>
                <div style={{ width: 32, height: 32, borderRadius: 8, background: 'rgba(16,185,129,0.25)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 16 }}>🌐</div>
                <span style={{ fontSize: 15, fontWeight: 700, color: '#6ee7b7' }}>Public Platform</span>
              </div>
              <div style={{ fontSize: 12, color: 'rgba(255,255,255,0.4)', lineHeight: 1.5 }}>
                Public OrgAdmins managing their organisation
              </div>
              <div style={{ fontSize: 11, color: 'rgba(16,185,129,0.7)', marginTop: 4 }}>
                public.privacy.education
              </div>
            </div>
            <div style={{ color: '#34d399', fontSize: 18 }}>→</div>
          </div>
        </a>

        <p style={{ fontSize: 11, color: 'rgba(255,255,255,0.18)', textAlign: 'center', marginTop: 28 }}>
          Unauthorised access attempts are logged.
        </p>
      </div>
    </div>
  );
}
